import ReactSelect from 'react-select';
import { customStyles } from '@/components/ui/inputFormik/select-input-formik';
import { useBranchesFilter } from '@/hooks/useBranchesFilter';

const BranchesDropdown = ({
  t,
  // selectedBranches,
  setSelectedBranches,
  locale,
  allBranches,

  isFromPDP = false,
}) => {
  const {
    selectedCity,
    selectedDistrict,
    searchInput,
    setSearchInput,
    cityOptions,
    districtOptions,
    handleCityChange,
    handleDistrictChange,
    handleSearch,
    handleReset,
    handleNearestToMe,
    CITY_ALL,
  } = useBranchesFilter(allBranches, setSelectedBranches, locale);

  return (
    <form
      onSubmit={handleSearch}
      className={`mb-4 grid grid-cols-1 items-end gap-3 rounded-2xl p-3 ${!isFromPDP ? 'bg-white shadow md:grid-cols-4' : 'md:grid-cols-3'} `}
    >
      {/* City Select */}
      <div>
        <label htmlFor='city' className='mb-1 block text-xs text-slate-500'>
          {t('city')}
        </label>
        <ReactSelect
          options={cityOptions}
          value={cityOptions.find((option) => option.value === selectedCity)}
          onChange={handleCityChange}
          styles={customStyles}
          placeholder={locale === 'en' ? 'Select City' : 'اختر المدينة'}
          isSearchable={true}
        />
      </div>

      {/* District Select */}
      <div>
        <label htmlFor='district' className='mb-1 block text-xs text-slate-500'>
          {t('district')}
        </label>
        <ReactSelect
          options={districtOptions}
          value={districtOptions.find(
            (option) => option.value === selectedDistrict
          )}
          onChange={handleDistrictChange}
          styles={customStyles}
          placeholder={locale === 'en' ? 'Select District' : 'اختر الحي'}
          isSearchable={true}
          isDisabled={selectedCity === CITY_ALL}
        />
      </div>

      {/* Search Input */}
      <div>
        <label htmlFor='search' className='mb-1 block text-xs text-slate-500'>
          {t('search_with_street_or_branch')}
        </label>
        <input
          value={searchInput}
          onChange={(e) => {
            setSearchInput(e.target.value);

            if (isFromPDP) {
              handleSearch(e);
            }
          }}
          placeholder={t(
            isFromPDP ? 'PDP_searchPlaceholder' : 'searchPlaceholder'
          )}
          className='w-full rounded-xl border border-slate-200 px-3 py-2.5'
        />
      </div>

      {/* Action Buttons */}
      {!isFromPDP && (
        <div className='flex flex-wrap gap-2 md:justify-end'>
          <button
            type='submit'
            className='rounded-xl bg-[#1e2b55] px-4 py-3 font-bold text-white'
          >
            {t('search')}
          </button>
          <button
            type='button'
            className='rounded-xl border border-[#1e2b55] bg-white px-4 py-3 font-bold text-[#1e2b55]'
            onClick={handleReset}
          >
            {t('reset')}
          </button>
          <button
            type='button'
            className='rounded-xl bg-emerald-600 px-4 py-3 font-bold text-white'
            onClick={handleNearestToMe}
          >
            {t('close_to_me')}
          </button>
        </div>
      )}
    </form>
  );
};

export default BranchesDropdown;
